import { Typography } from 'antd';
import styles from './index.less';

const { Title, Paragraph, Text, Link } = Typography;
const NoMenu = () => (
  <Typography className={styles.noMenu}>
    <Title className={styles.title}>欢迎访问{process.env.REACT_APP_PROJECT_NAME}</Title>
    <Paragraph className={styles.content}>
      您暂时没有权限，请联系管理员！
    </Paragraph>
  </Typography>
);

export default NoMenu;
